/**
 * @generated SignedSource<<574069c86901a0c3062851191b4f1cb5>>
 * @relayHash 6f452febb43ea4f48f12803ae2f36059
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f27b717aa3dee1fea8e5e08bba80fa1c21b2e8edc62a059010667c927a5cc976

import type { ConcreteRequest } from 'relay-runtime';
export type HelpCenterNavMenuItemType = "PORTALS" | "TOPICS" | "%future added value";
export type HelpCenterNavigationBarBorderType = "ALL_BORDER" | "BOTTOM_BORDER" | "NO_BORDER" | "%future added value";
export type HelpCenterNavigationBarPositionType = "FIXED" | "FLOATING" | "%future added value";
export type HelpCenterSpaceDensity = "BREEZY" | "COMFORTABLE" | "COMPACT" | "DEFAULT" | "%future added value";
export type HelpCenterTemplateType = "DEFAULT" | "DEMO_SITES" | "%future added value";
export type HelpCenterTypeInput = "BASIC" | "CUSTOMER_SERVICE" | "HELP_HUB" | "%future added value";
export type HelpCenterCreateInput = {
  helpCenterBranding?: HelpCenterBrandingInput | null;
  helpCenterType?: HelpCenterTypeInput | null;
  homePageLayout?: HelpCenterHomePageLayoutInput | null;
  name: HelpCenterNameInput;
  projectMapping?: HelpCenterAddProjectMappingInput | null;
  rovoConfig?: HelpCenterRovoConfig | null;
  slug: string;
  templateType?: HelpCenterTemplateType | null;
  workspaceARI: string;
};
export type HelpCenterBrandingInput = {
  banner?: HelpCenterBannerInput | null;
  colors?: HelpCenterBrandingColorsInput | null;
  cornerRadius?: number | null;
  helpCenterIcon?: string | null;
  homePageTitle?: HelpCenterHomePageTitleInput | null;
  logo?: HelpCenterLogoInput | null;
  navigationBar?: HelpCenterNavigationBarInput | null;
  spaceDensity?: HelpCenterSpaceDensity | null;
  typography?: HelpCenterBrandingTypographyInput | null;
};
export type HelpCenterBannerInput = {
  filedId?: string | null;
  useDefaultBanner?: boolean | null;
};
export type HelpCenterBrandingColorsInput = {
  bannerTextColor?: string | null;
  primary?: string | null;
  secondaryColor?: string | null;
  topBarColor?: string | null;
  topBarTextColor?: string | null;
};
export type HelpCenterHomePageTitleInput = {
  default: string;
  translations?: ReadonlyArray<HelpCenterTranslationInput | null> | null;
};
export type HelpCenterTranslationInput = {
  locale: string;
  localeDisplayName?: string | null;
  value: string;
};
export type HelpCenterLogoInput = {
  fileId?: string | null;
};
export type HelpCenterNavigationBarInput = {
  backgroundColor?: string | null;
  borderColor?: string | null;
  borderType?: HelpCenterNavigationBarBorderType | null;
  cornerRadius?: number | null;
  hiddenMenus?: ReadonlyArray<HelpCenterNavMenuItemType> | null;
  padding?: boolean | null;
  positionType?: HelpCenterNavigationBarPositionType | null;
  textColor?: string | null;
};
export type HelpCenterBrandingTypographyInput = {
  bodyFont?: string | null;
  headingFont?: string | null;
};
export type HelpCenterHomePageLayoutInput = {
  layoutAdf?: string | null;
  metadata?: string | null;
};
export type HelpCenterNameInput = {
  default: string;
  translations?: ReadonlyArray<HelpCenterTranslationInput | null> | null;
};
export type HelpCenterAddProjectMappingInput = {
  projectIds?: ReadonlyArray<string> | null;
  syncNewProjects?: boolean | null;
};
export type HelpCenterRovoConfig = {
  agentId?: string | null;
  isRovoEnabled?: boolean | null;
};
export type useHelpCenterCreateMutation$variables = {
  cloudId: string;
  input: HelpCenterCreateInput;
};
export type useHelpCenterCreateMutation$data = {
  readonly helpCenter: {
    readonly createHelpCenter: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null;
        } | null;
        readonly message: string | null;
      }> | null;
      readonly helpCenterAri: string | null;
      readonly success: boolean;
    } | null;
  } | null;
};
export type useHelpCenterCreateMutation = {
  response: useHelpCenterCreateMutation$data;
  variables: useHelpCenterCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v6 = {
  "kind": "ScalarField",
  "name": "helpCenterAri"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useHelpCenterCreateMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterMutationApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "HelpCenterCreatePayload",
            "kind": "LinkedField",
            "name": "createHelpCenter",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useHelpCenterCreateMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterMutationApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "HelpCenterCreatePayload",
            "kind": "LinkedField",
            "name": "createHelpCenter",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f27b717aa3dee1fea8e5e08bba80fa1c21b2e8edc62a059010667c927a5cc976",
    "metadata": {},
    "name": "useHelpCenterCreateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "50311be3a83d4bcff60feddeba10c3e5";

export default node;
